import { useCallback, useEffect, useState } from "react";
import { CalendarPlus } from "lucide-react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Panel } from "@/components/crm/Badges";
import { AppointmentDialog } from "@/components/crm/appointments/AppointmentDialog";
import { STATUS_TONE } from "@/pages/crm/AppointmentsPage";

export const AppointmentsPanel = ({ lead, requests = [], onChanged }) => {
  const [items, setItems] = useState([]);
  const [dialog, setDialog] = useState(null);
  const load = useCallback(() => { api.get("/appointments", { params: { lead_id: lead.id } }).then((r) => setItems(r.data)); }, [lead.id]);
  useEffect(() => { load(); }, [load, lead.assigned_seller_id]);
  const saved = () => { load(); onChanged?.(); };
  const pending = requests.filter((r) => r.status === "pendiente");

  return (
    <Panel title="Citas" icon={CalendarPlus} testid="lead-appointments-panel">
      <div className="space-y-2">
        {items.length === 0 && <p className="text-sm text-slate-400" data-testid="lead-appointments-empty">Sin citas</p>}
        {items.map((a) => (
          <button key={a.id} onClick={() => setDialog({ appointment: a })} data-testid={`lead-appointment-${a.id}`}
                  className={`block w-full rounded-xl border px-3 py-2 text-left text-sm ${STATUS_TONE[a.status]}`}>
            <b>{a.date} {a.time}</b> · {a.service_name || "Sin servicio"} <span className="float-right text-xs">{a.status}</span>
          </button>
        ))}
        {pending.map((r) => (
          <div key={r.id} className="flex items-center justify-between rounded-xl border border-dashed border-amber-300 bg-amber-50 px-3 py-2 text-sm" data-testid={`appointment-request-${r.id}`}>
            <span>Solicitud web: {r.preferred_date} {r.preferred_time} · {r.service_name || "—"}</span>
            <button className="text-xs font-semibold text-[#1E6FD9]" data-testid={`appointment-request-convert-${r.id}`}
                    onClick={() => setDialog({ requestId: r.id, defaults: { date: r.preferred_date, time: r.preferred_time } })}>Convertir en cita</button>
          </div>
        ))}
        <Button variant="outline" className="mt-1 w-full rounded-xl" onClick={() => setDialog({})} data-testid="lead-appointment-new-button">
          <CalendarPlus className="mr-1.5 h-4 w-4" /> Nueva cita
        </Button>
      </div>
      <AppointmentDialog open={Boolean(dialog)} onOpenChange={(v) => !v && setDialog(null)} lead={lead}
                         appointment={dialog?.appointment} requestId={dialog?.requestId} defaults={dialog?.defaults} onSaved={saved} />
    </Panel>
  );
};
